import { Patient } from "@medplum/fhirtypes";

import { createEntityAdapter, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "..";

const clientsAdapter = createEntityAdapter({
  selectId: (client: Patient) => client.id!,
});

interface ClientsState {
  entities: ReturnType<typeof clientsAdapter.getInitialState>["entities"];
  ids: ReturnType<typeof clientsAdapter.getInitialState>["ids"];
  showOnlyMyClients: boolean;
}

const initialState: ClientsState = {
  ...clientsAdapter.getInitialState(),
  showOnlyMyClients: false,
};

const reducers = {
  loadClients: clientsAdapter.setAll,
  createManyClients: clientsAdapter.addMany,
  createClient: clientsAdapter.addOne,
  removeClient: clientsAdapter.removeOne,
  updateClient: clientsAdapter.updateOne,
  upsertClient: clientsAdapter.upsertOne,
  setShowOnlyMyClients: (state: { showOnlyMyClients: boolean }, action: PayloadAction<boolean>) => {
    state.showOnlyMyClients = action.payload;
  },
};

export const clientsSlice = createSlice({
  name: "clients",
  initialState,
  reducers,
});

export const {
  loadClients,
  createClient,
  createManyClients,
  removeClient,
  updateClient,
  upsertClient,
  setShowOnlyMyClients,
} = clientsSlice.actions;

const clientsSelectors = clientsAdapter.getSelectors((state: RootState) => state.clients);

/** Ordered by `ids` from the last `loadClients` (preserves EDD / custom sorts). */
export const selectClientsList = clientsSelectors.selectAll;

export default clientsSlice.reducer;
